/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class LocationTableApi extends runtime.BaseAPI {
    /**
     * Create Location Table
     */
    async v2CreateLocationTableRaw(requestParameters, initOverrides) {
        if (requestParameters['locationTableCreate'] == null) {
            throw new runtime.RequiredError('locationTableCreate', 'Required parameter "locationTableCreate" was null or undefined when calling v2CreateLocationTable().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/location-table/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['locationTableCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Location Table
     */
    async v2CreateLocationTable(requestParameters, initOverrides) {
        const response = await this.v2CreateLocationTableRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
